import * as ng from 'angular';

class FatturazionePAController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
        'store'
    ];

    constructor(
        private $scope: any,
        private $rootScope: any,
        private store: ng.a0.storage.IStoreService
    ) {
        $scope.user = store.get('user');
        /* tslint:disable:no-string-literal */
        $rootScope.accepted = false;
        $scope.pageHeader = 'Fatturazione per la Pubblica Amministrazione';
        $scope.tooltips = {
            'create': 'Crea la tua fattura elettronica PA e trasmettila allo Sdi in pochi facili passi.',
            'upload': 'Carica il file XML di una fattura elettronica PA creata con strumenti,\nsoftware o servizi diversi da ArchiSMALL e trasmettilo allo Sdi.',
            'check': 'Consulta le tue fatture inviate alla Pubblica Amministrazione e visualizza le relative notifiche.\nSe hai dei dubbi sugli stati della fattura segui i consigli di ArchiSMALL.'
        };
    }

}

export const FatturazionePAComponent: ng.IComponentOptions = {
    template: require('./fatturazione-pa.html'),
    controller: FatturazionePAController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pa/fatturazione-pa.ts